import request from '../utils/Request'

export function sendOauth(params){
    return new Promise((resolve, reject) => {
        request.post("/socials/wechat/authorizations",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}
export function getUserInfo(params){
    return new Promise((resolve, reject) => {
        request.get("/me",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}
export function rechargePhone(params){
    return new Promise((resolve, reject) => {
        request.post("/telephonerecharge",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}
export function rechargePower(params){
    return new Promise((resolve, reject) => {
        request.post("/power",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}

export function useCard(params){
    return new Promise((resolve, reject) => {
        request.post("/opencard",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}
export function getUserRechargeList(params){
    return new Promise((resolve, reject) => {
        request.get("/getmoneyinfo",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}

export function openList(params){
    return new Promise((resolve, reject) => {
        request.get("/openlist",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}

export function useList(params){
    return new Promise((resolve, reject) => {
        request.get("/uselist",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}
export function orderList(params){
    return new Promise((resolve, reject) => {
        request.get("/orders",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}

export function refreshToken(params){
    return new Promise((resolve, reject) => {
        request.put("/authorizations/current",params).then(result=>{
            resolve(result)
        }).catch(err=>{
            reject(err)
        });
    })
}

